/**
 * 資料異動通知（R28）
 *
 * 新增／編輯／刪除（含批次、封存、匯入）在 API「成功之後」呼叫 notifyDataChanged(topic)，統一處理：
 * - 儀表板統計、動態記錄快取重新載入（tasks 另外更新「即將到期」）——原本 51 處各自動態 import store，刷新範圍還不一致
 * - opportunities：清掉銷售漏斗與階段統計的 localStorage 快取
 * - 發出事件（@redpanda/utils emitDataChanged）：訂閱者（列表搜尋結果、漏斗、看板、詳情頁區塊）各自重新載入
 *
 * 注意：對話框是樂觀更新，onClose 在 API 完成前就會觸發，「重新抓資料」一律掛在這個事件上，不要掛在對話框關閉時
 */
import { emitDataChanged, useDataChangedEvent } from '@redpanda/utils';
import { useDashboardStore } from '../stores/dashboardStore';
import { useActivityStore } from '../stores/activityStore';
import { useUpcomingTasksStore } from '../stores/taskStore';

export type DataTopic = 'customers' | 'projects' | 'quotes' | 'payments' | 'tasks' | 'opportunities' | 'tags' | 'interactions';

export const SALES_FUNNEL_CACHE_KEY = 'sales-funnel-cache';
export const STAGE_STATS_CACHE_KEY = 'opportunity-stage-stats';

export const notifyDataChanged = (topic: DataTopic) => {
  if (topic === 'opportunities') {
    try {
      localStorage.removeItem(SALES_FUNNEL_CACHE_KEY);
      localStorage.removeItem(STAGE_STATS_CACHE_KEY);
    } catch { /* localStorage 不可用時略過 */ }
  }

  useDashboardStore.getState().fetchDashboardStats(true);
  useActivityStore.getState().invalidateCache();
  if (topic === 'tasks') {
    useUpcomingTasksStore.getState().fetchUpcomingTasks(true);
  }

  emitDataChanged(topic);
};

/** 訂閱資料異動（共用實作 @redpanda/utils dataEvents）；handler 不需要 memo */
export const useDataChanged = (topic: DataTopic | DataTopic[], handler: () => void) => useDataChangedEvent(topic, handler);
